import { FootNoteInlineSpecExtension } from '@blocksuite/hive-inline-footnote';
import { LatexInlineSpecExtension } from '@blocksuite/hive-inline-latex';
import { LinkInlineSpecExtension } from '@blocksuite/hive-inline-link';
import { MentionInlineSpecExtension } from '@blocksuite/hive-inline-mention';
import { ReferenceInlineSpecExtension } from '@blocksuite/hive-inline-reference';
import type { HiveTextAttributes } from '@blocksuite/hive-shared/types';
import { InlineManagerExtension } from '@blocksuite/std/inline';

import {
  BackgroundInlineSpecExtension,
  BoldInlineSpecExtension,
  CodeInlineSpecExtension,
  ColorInlineSpecExtension,
  ItalicInlineSpecExtension,
  StrikeInlineSpecExtension,
  UnderlineInlineSpecExtension,
} from './inline-spec';

export const DefaultInlineManagerExtension =
  InlineManagerExtension<HiveTextAttributes>({
    id: 'DefaultInlineManager',
    specs: [
      BoldInlineSpecExtension.identifier,
      ItalicInlineSpecExtension.identifier,
      UnderlineInlineSpecExtension.identifier,
      StrikeInlineSpecExtension.identifier,
      CodeInlineSpecExtension.identifier,
      BackgroundInlineSpecExtension.identifier,
      ColorInlineSpecExtension.identifier,
      LatexInlineSpecExtension.identifier,
      ReferenceInlineSpecExtension.identifier,
      LinkInlineSpecExtension.identifier,
      FootNoteInlineSpecExtension.identifier,
      MentionInlineSpecExtension.identifier,
    ],
  });
